import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Grid from '@mui/material/Grid';
import Toolbar from '@mui/material/Toolbar';
import logo from './LogoColoredTransparentSmall.png';
import OperatorLogout from '../../login/components/OperatorLogout';
import PropTypes from 'prop-types';

function Header({onAuthChange}) {
  return (
    <React.Fragment>
      <AppBar
        component="div"
        color="primary"
        position="sticky"
        elevation={0}
        sx={{zIndex: 0}}
      >
        <Toolbar>
          <Grid container alignItems="center" justifyContent={'space-between'} spacing={1}>
            <Grid item xs={1}>
              <OperatorLogout onLogoutAttempt={onAuthChange}/>
            </Grid>
            <Grid item align={'center'} sx={{height: '10vh'}}>
              <img src={logo} className="logo" alt="Logo"/>
            </Grid>
            <Grid item xs={1}>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </React.Fragment>
  );
}

Header.propTypes = {
  onAuthChange: PropTypes.func.isRequired,
};

export default Header;
